// import { lazy } from "@loadable/component";
// import { Suspense } from "react";
// import { ErrorBoundary } from "@sentry/react";
// import { ErrorFallback } from "../../patterns";
// import { CustomFormsLoading } from "./CustomForms.loading";
// import { CustomFormsProps } from "./CustomForms.types";

// export const CustomFormsLoadable = lazy(() => import("./CustomForms"));

// export const CustomForms = (props: CustomFormsProps) => (
//   <ErrorBoundary fallback={<ErrorFallback />}>
//     <Suspense fallback={<CustomFormsLoading />}>
//       <CustomFormsLoadable {...props} />
//     </Suspense>
//   </ErrorBoundary>
// );

import { lazy } from "@loadable/component";
import { Suspense, useEffect, useState } from "react";
import { ErrorBoundary } from "@sentry/react";
import { ErrorFallback } from "../../patterns";
import { CustomFormsLoading } from "./CustomForms.loading";
import { CustomFormsProps } from "./CustomForms.types";
import { addTranslationResources } from "./CustomForms.translations";

export const CustomFormsLoadable = lazy(() => import("./CustomForms"));

export const CustomForms = (props: CustomFormsProps) => {
  const { i18next } = props;
  const [resourcesLoaded, setResourcesLoaded] = useState(false);

  useEffect(() => {
    // Load translation resources
    addTranslationResources(i18next);
    setResourcesLoaded(true);
  }, [i18next]);

  if (!resourcesLoaded) return <CustomFormsLoading />;

  return (
    <ErrorBoundary fallback={<ErrorFallback />}>
      <Suspense fallback={<CustomFormsLoading />}>
        <CustomFormsLoadable {...props} />
      </Suspense>
    </ErrorBoundary>
  );
};

